export { default } from "./Promotions.jsx";
